const commonExts = {
  video: ['mp4', 'flv', 'avi', 'wmv', 'mpeg', '3gp', 'm4v', 'mov', 'asf', 'f4v', 'rmvb', 'rm', 'vob'],
  audio: ['mp3', 'wav', 'ogg', 'm4a', 'midi'],
  image: ['jpg', 'png', 'jpeg', 'svg', 'gif', 'webp', 'bmp']
}

export function getFileType(filename) {
  const lastDotIndex = filename.lastIndexOf('.')
  if (lastDotIndex === -1) {
    return 'bin'
  }
  const ext = filename.substring(lastDotIndex + 1).toLowerCase()
  switch (ext) {
    case 'ppt':
    case 'pptx':
      return 'ppt'
    case 'xls':
    case 'xlsx':
      return 'excel'
    case 'doc':
    case 'docx':
      return 'word'
    case 'pdf':
      return 'pdf'
    default:
  }

  for (const key in commonExts) {
    if (commonExts[key].includes(ext)) {
      return key
    }
  }

  return 'bin'
}
